export default "__VITE_ASSET__7f40d277__"